/**
 * Parse de markdown do painel Orya (prose + tabelas).
 */

function splitMarkdownCells(line) {
  const trimmed = String(line || '').trim();
  if (!trimmed.includes('|')) return null;
  const inner = trimmed.replace(/^\|/, '').replace(/\|$/, '');
  return inner.split('|').map((c) => c.trim());
}

function isSeparatorRow(cells) {
  return cells?.length > 0 && cells.every((c) => /^:?-{2,}:?$/.test(c));
}

export function parseTableAt(lines, startIdx) {
  const header = splitMarkdownCells(lines[startIdx]);
  if (!header?.length || isSeparatorRow(header)) return null;

  let i = startIdx + 1;
  if (i < lines.length) {
    const sep = splitMarkdownCells(lines[i]);
    if (sep && isSeparatorRow(sep)) i += 1;
  }

  const rows = [];
  while (i < lines.length) {
    const line = lines[i];
    if (!String(line).trim().startsWith('|')) break;
    const row = splitMarkdownCells(line);
    if (row && isSeparatorRow(row)) break;
    if (row) {
      const padded = [...row];
      while (padded.length < header.length) padded.push('');
      rows.push(padded.slice(0, header.length));
    }
    i += 1;
  }

  return { headers: header, rows, nextIdx: i };
}

export function stripMarkdownBold(text) {
  return String(text || '')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .trim();
}

/**
 * @returns {{ blocks: Array<{ type: 'prose'|'table', lines?: string[], title?: string, headers?: string[], rows?: string[][] }> }}
 */
export function parseOryaPanelMarkdown(markdown) {
  const lines = String(markdown || '').split(/\r?\n/);
  const blocks = [];
  let pendingTitle = null;
  let i = 0;

  while (i < lines.length) {
    const table = parseTableAt(lines, i);
    if (table) {
      blocks.push({
        type: 'table',
        title: pendingTitle,
        headers: table.headers,
        rows: table.rows,
      });
      pendingTitle = null;
      i = table.nextIdx;
      continue;
    }

    const trimmed = lines[i]?.trim() || '';
    if (!trimmed) {
      i += 1;
      continue;
    }

    if (/^\*\*[^*]+\*\*$/.test(trimmed)) {
      pendingTitle = stripMarkdownBold(trimmed);
      i += 1;
      continue;
    }

    const prose = [];
    while (i < lines.length) {
      const t = lines[i]?.trim() || '';
      if (!t) break;
      if (parseTableAt(lines, i)) break;
      if (/^\*\*[^*]+\*\*$/.test(t)) break;
      prose.push(lines[i]);
      i += 1;
    }
    if (prose.length) {
      blocks.push({ type: 'prose', lines: prose });
    } else {
      i += 1;
    }
  }

  return { blocks };
}

export function countMarkdownTables(markdown) {
  const lines = String(markdown || '').split(/\r?\n/);
  let count = 0;
  let i = 0;
  while (i < lines.length) {
    const table = parseTableAt(lines, i);
    if (table) {
      count += 1;
      i = table.nextIdx;
    } else {
      i += 1;
    }
  }
  return count;
}
